import React from 'react';
import classNames from 'classnames';

export default function ChevronDownIcon({ className = '' }) {
	return <span className={classNames('icon icon-caret_down', className)} />;
}
